var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"app":"","color":"primary"}}),_vm._v(" "),_c('v-main',{staticClass:"derecha"},[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('v-card',{staticClass:"elevation-3",attrs:{"tile":""}},[_c('v-card-text',[_vm._v("\n              Gracias por utilizar el servicio.\n            ")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"outlined":"","to":{ name: 'Login' }}},[_vm._v("\n                Entrar\n              ")])],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/user/Logout.vue?vue&type=template&id=fee4262c
// module id = null
// module chunks = 